
import { Vue, Component, Prop,Watch } from "vue-property-decorator";
import textEditor from "./text-editor.vue";
import uploadFile from "./uploadFile.vue";
import JsonEdit from "./JsonEdit.vue";
import { BaseVue } from "@newview/base-web";
@Component({
  name: "comForm",
  components: {
    textEditor,
    uploadFile,
    JsonEdit
  }
})
export default class comForm extends BaseVue {
  @Prop({ default: () => [] }) listData!: any; //表单项列表
  @Prop({ default: "Name" }) textKey!: any; //表单项绑定对象
  @Prop({ default: true }) isFirst!: boolean; //是否默认选中第一条
  @Prop({ default: false }) multiple!: boolean; //是否多选
  // activeData=""
  activeIndex = -1
  @Watch("listData")
  listDataChange(){
    if(this.isFirst){
      if(this.listData.length>0){
        this.clickListItem(this.listData[0],0)
      }
    }
  }
  mounted(){
    if(this.isFirst){
      if(this.listData.length>0){
        this.clickListItem(this.listData[0],0)
      }
    }
    
  }
  clickListItem(activeData,key){
    if(this.multiple){
      return
    } 
    this.activeIndex = key
    // this.activeData = JSON.stringify(activeData)
    this.$emit("on-change",activeData,key)
  }
  checkBoxChange(row,state,index){
    this.$emit("on-check",row,state,index)
  }

  getCheckedData(){
    return this.Baselinq.from(this.listData).where(e=>e["checked"]==true).toArray()
  }
  

}
